export default {
    BASE_URL: 'admin/member/audit',
    api: [
        {
            name: 'pending',
            desc: '获取待审核列表',
            method: 'GET',
            path: '/pending'
        },
        {
            name: 'completed',
            desc: '获取已审核列表',
            method: 'GET',
            path: '/completed'
        },
        {
            name: 'detail',
            desc: '获取审核详情',
            method: 'GET',
            path: '/detail'
        },
        {
            name: 'fail',
            desc: '审核不通过',
            method: 'PUT',
            path: '/fail'
        },
        {
            name: 'pass',
            desc: '审核通过',
            method: 'PUT',
            path: '/pass'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/member/audit.js